<template>
<div id="nav">
	<div class="wid1010">
		<ul id="ul_nav">
      <li>
        <a :href="homeUrl" target="_self"><span>首 页</span></a>
      </li>
      <li v-for="(outer, i) in menus" v-if="!outer.parentId">
        <a :href="outer.url"  target="_self" :class="getClass(outer.name)"><span>{{outer.name}}</span></a>
        <ul style="z-index: 999;">
          <li v-for="(inner, i) in menus" v-if="inner.parentId == outer.id">
            <a :href="inner.url">{{inner.name}}</a>
          </li>
        </ul>
      </li>
		</ul>
	</div>
</div>
</template>

<script>
  export default {
    name: 'navigateView',
    data() {
      return {
        homeUrl: process.env.VUE_APP_API_URL,
        menus: [],
      }
    },
    created() {
      this.channelMenu();
    },
    methods: {
      channelMenu(){
        this.$api.dashboardApi.getChannelMenu().then(response => {
          if(response.status === 200){
            if(response.data.code === 200){
              this.menus = JSON.parse(response.data.data);
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          console.error(error);
        });
      },
      getClass(name) {
        const array = ['集中议价', '疫苗采购']
        let len = array.length
        while(len--){
          if(array[len] === name){
            return 'current';
          }
        }
        return '';
        // ==='集中议价'?'current':''
      }
    }
  }
</script>
<style>
.wid1010 {
    width: 1010px;
    margin: 0 auto;
}
#nav {
	height: 38px;
  font-size: 15px;
  margin: 0px auto;
}
#nav li {
	width: 160px;
	float: left;
}
#nav li a {
	display: block;
	text-align: center;
	line-height: 38px;
  width: 160px;
  color:#fff;
}
#nav li a:hover {
	font-weight: bold;
	line-height:38px;
  width:160px;
	background:#d22e22;
	color:#fff;
}
#nav li .current {
	font-weight: bold;
	line-height:38px;
	background:#d02820;
	color:#fff;
}
#ul_nav {
  line-height: 20px; list-style-type: none; background:#666;
}
#ul_nav li ul {
  line-height: 27px; list-style-type: none;text-align:left;
  left: -999em; width: 160px; position: absolute;
}
#ul_nav li ul li{
  float: left; width: 160px;
  background: rgb(0,132,197);
  opacity:0.8;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);
}
#ul_nav li ul a{
  wedisplay: block; width: 160px;text-align:center;margin:0px auto;
}
#ul_nav li ul a:link {
  color:#fff; text-decoration:none;
}
#ul_nav li ul a:visited {
  color:#fff;text-decoration:none;
}
#ul_nav li ul a:hover {
  color:#F3F3F3;text-decoration:none;font-weight:normal; width: 160px;
  background:rgb(0,132,197);
  opacity:0.8;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);
}
#ul_nav li:hover ul {
  left: auto;
}
#ul_nav li.sfhover ul {
  left: auto;
}
.fl{
	float:left;
}
.fr{
	float:right;
}
</style>



// WEBPACK FOOTER //
// src/components/common/NavigateView.vue